export default __webpack_public_path__ + "static/media/addIcon.2986d9fc.svg";